var map = {
	"./esm/en.json": "1188",
	"./esm/fr.json": "ae5c",
	"./harveys/en.json": "ef36",
	"./harveys/fr.json": "a98e",
	"./kelseys/en.json": "abfb",
	"./kelseys/fr.json": "b715",
	"./montanas/en.json": "59b9",
	"./montanas/fr.json": "bbe3",
	"./st-hubert/en.json": "9746",
	"./st-hubert/fr.json": "18b4",
	"./swiss/en.json": "e85c",
	"./swiss/fr.json": "e5c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";